export const ModalFooter: React.FC<any> = ({ children }): any => (
	<div>{children}</div>
);
ModalFooter.defaultProps = {
	__TYPE: 'ModalFooter'
};

export default ModalFooter;
